import React, { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Context } from "../../context";
import SliderUnstyled from "@mui/base/SliderUnstyled";
import Checkbox from "../form/checkbox.js";
import filtersSlice from "../../../state/filtersSlice.js";
import formatPrice from "../../../utils/formatPrice.js";
const { registerFilter, resetFilter, changeFilterValue } = filtersSlice.actions;
/*
 * EXEMPLE
  <form
    onSubmit={ (e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
    noValidate={true}
    className={ "gform label-top_label description-below" }
  >
    <Filter type="Attributes" label="Couleur" name="color"/>
    <Filter type="Attributes" label="Taille" name="size"/>
    <Filter type="Sale" label="En solde" />
    <Filter type="Price" label="Prix" />
  </form>
*/
const Filter = (props) => {
    const filters = useSelector((state) => state.filters);
    const dispatch = useDispatch();
    const context = useDispatch(Context);
    const registerFilterDispatch = () => {
        const filter = {};
        if (!props.type) {
            return;
        }
        filter.type = props.type;
        filter.label = props.label || props.type;
        filter.id = props.type.toLowerCase();
        try {
            filter.values = [
                ...context.wc.allFilters.wp_gql["product" + props.type].nodes,
            ];
        }
        catch {
            if (props.type === "Attributes") {
                const allAttributes = [
                    ...new Set(context.wc.allFilters.wp_gql.products.nodes
                        .filter((p) => p.attributes && p.attributes.nodes.length)
                        .flatMap((p) => p.attributes.nodes
                        .filter((attr) => attr && Object.keys(attr).length)
                        .flatMap((attr) => {
                        return {
                            ...attr,
                            terms: attr.terms.nodes,
                        };
                    }))),
                ];
                const attribute = allAttributes
                    .filter((e) => e.name.toLowerCase() === props.name.toLowerCase() ||
                    e.id === props.id)
                    .reduce((a, b) => {
                    a.terms = [...(a.terms || []), ...(b.terms || [])].filter((term, index, arr) => {
                        return !arr.find((e, i) => i > index && e.id === term.id);
                    });
                    return a;
                });
                filter.values = attribute.terms;
                filter.id = props.type.toLowerCase() + props.name.toLowerCase();
            }
            else if (props.type === "Price") {
                const maxPrice = Math.max(...allFilters.wp_gql.products.nodes
                    .map((e) => {
                    if (!e || !e.price) {
                        return 0;
                    }
                    return (Math.max(...e.price.split("-").map((price) => {
                        return parseFloat(price.trim().replace(/,/gi, "."));
                    })) || 0);
                })
                    .filter((e) => e));
                filter.values = { min: props.min || 0, max: props.max || maxPrice };
            }
            else if (props.type === "InStock" || props.type === "Sale") {
                filter.values = "boolean";
            }
        }
        dispatch(registerFilter(filter));
    };
    //~ if (typeof windows === "undefined") {
    registerFilterDispatch();
    //~ } else {
    //~ useEffect(() => {
    //~ registerFilterDispatch();
    //~ }, []);
    //~ }
    /*
     * IL FAUDRA ADAPTER LE RENDU EN FONCTION DE CE QUI EST SOUHAITÉ
     * voir le site d'AGIS pour reproduire les filtres
     */
    const currentFilter = filters[props.type.toLowerCase() + (props.name || "").toLowerCase()];
    if (!currentFilter) {
        return React.createElement(React.Fragment, null);
    }
    if (currentFilter.values === "boolean") {
        return (React.createElement(Checkbox, { choices: [
                {
                    text: currentFilter.label,
                    value: currentFilter.id,
                    isSelected: currentFilter.value === currentFilter.id,
                },
            ], visibility: "visible", onValidate: () => { }, onChange: (value) => {
                dispatch(changeFilterValue({ id: currentFilter.id, value }));
            }, label: currentFilter.label }));
    }
    if (currentFilter.type === "Price") {
        return (React.createElement("label", { className: "MuiSlider-label" },
            React.createElement("span", { className: "label" }, currentFilter.label),
            React.createElement(SliderUnstyled, { onChange: (e) => dispatch(changeFilterValue({
                    id: currentFilter.id,
                    value: {
                        min: e.target.value[0],
                        max: e.target.value[1],
                    },
                })), "aria-label": currentFilter.label, min: currentFilter.values.min, max: currentFilter.values.max, valueLabelDisplay: "on", valueLabelFormat: (value) => formatPrice(value, {
                    ...context.wc.settings,
                    woocommercePriceNumDecimals: 0,
                }), defaultValue: Object.values(currentFilter.value || currentFilter.values) })));
    }
    return (React.createElement(Checkbox, { choices: currentFilter.values.map((e) => ({
            text: e.name,
            value: e.id,
            isSelected: e.id === currentFilter.value,
        })), visibility: "visible", multiple: true, onValidate: () => { }, onChange: (value) => {
            dispatch(changeFilterValue({ id: currentFilter.id, value }));
        }, label: currentFilter.label }));
};
export default Filter;
